import { useEffect } from 'react';
import { useAuthManager } from '../contexts/authManager';

export const IDLE_TIMEOUT_MINUTES = parseFloat(
  import.meta.env.VITE_IDLE_TIMEOUT_MINUTES || '30',
);

export const REFRESH_INTERVAL_SECONDS = parseInt(
  import.meta.env.VITE_IDLE_REFRESH_INTERVAL_SECONDS || '60',
);

export const useAdminSectionActivityHandler = (): void => {
  const {
    requestAuthExpirationCheck,
    reportAuthActivity,
    hasAuthBeenInactiveForTooLong,
    requestLogoutRedirect,
    addAuthExpirationListener,
    removeAuthExpirationListener,
  } = useAuthManager();

  useEffect(() => {
    const handleEvent = () => reportAuthActivity();

    window.addEventListener('mousemove', handleEvent);
    window.addEventListener('keydown', handleEvent);
    window.addEventListener('click', handleEvent);

    // 1. Listen to auth expiration
    const authExpirationListener = () => {
      void requestLogoutRedirect('/');
    };

    addAuthExpirationListener(authExpirationListener);

    // 2. Periodically check if the user has been inactive for too long or if the auth has expired
    const checkInactivityOrAuthenticationExpiration = async () => {
      if (hasAuthBeenInactiveForTooLong(IDLE_TIMEOUT_MINUTES)) {
        await requestLogoutRedirect('/');
        return;
      }
      void requestAuthExpirationCheck();
    };

    // 3. Check for inactivity in the first load
    void checkInactivityOrAuthenticationExpiration();

    const intervalId = setInterval(() => {
      void checkInactivityOrAuthenticationExpiration();
    }, REFRESH_INTERVAL_SECONDS * 1000);

    return () => {
      window.removeEventListener('mousemove', handleEvent);
      window.removeEventListener('keydown', handleEvent);
      window.removeEventListener('click', handleEvent);

      window.clearInterval(intervalId);

      removeAuthExpirationListener(authExpirationListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
